import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { actionRegList, DwAuthGuardService, DwLoginComponent, DwRouteGuardUtil, DwSsoLoginComponent, UserProfileComponent, DwUserRegistrationComponent, DevwareGetStartedComponent, DwGridQuickSearchActionComponent, DwGridCancelInlineEditsActionService, DwActionFunc, DwActionType, DwDecoratorType, DwGridActionConfig, DwGridActionKeys, DwGridQuickSearchConfigComponent, _dwActionGridQuickSearch, DwGridColumnActionButtonsComponent, DwPage404Component, DwCanDeactivateGuard, DevwareAdminModule } from '@devwareapps/devware-cap';
import { AviatorOnlineHomePageComponent } from './features/homepage/components/aviator-online-home-page/aviator-online-home-page.component';
import { CourseCardComponent } from './features/courses/components/cards/course-card/course-card.component';
import { CoursePageComponent } from './features/courses/components/course-page/course-page.component';
import { CourseStudentProgressCardComponent } from './features/courses/components/cards/course-student-progress-card/course-student-progress-card.component';
import { ManagerUserUtilComponent } from './features/schools/components/manager-user-util/manager-user-util.component';
import { DwComponentList } from './app-routing-tree-shaking';
import { AviatorRouteGuardService } from './features/shared/route-guards/aviator-route-guard.service';
import { AviatorLoginPageComponent } from './features/homepage/components/aviator-login-page/aviator-login-page.component';
import { AviatorRegistrationPageComponent } from './features/homepage/components/aviator-registration-page/aviator-registration-page.component';
import { AviatorNotFoundComponent } from './features/homepage/components/aviator-not-found/aviator-not-found.component';



@Component({
    selector: 'sevice-dependencies',
    template: `Service Dependencies`,
})
export class ServiceDependenciesComponent { 
    constructor(private dwGridCancelInlineEditsActionService: DwGridCancelInlineEditsActionService) {}
}

const routes = [
    {
        path: '',
        component: AviatorOnlineHomePageComponent,
        data: {
            display: 'Dashboard',
            iconCssClass: 'fa fa-menu-icon fa-home',
            routeOrder: 5,
            hideBreadcrumbParent: true,
            excludeFromMainMenu: false,
            showInMenu: true,
            highlightOnExactMatch: true,
            referenceKey: 'home',
        }
    },  
    {
        path: 'login',
        component: AviatorLoginPageComponent,
        canActivate: [AviatorRouteGuardService],
        data: {
            routeId: 'login',
            display: 'Login',
            iconCssClass: 'fa fa-menu-icon fa-power-off',
            showInMenu: false,
            referenceKey: 'login'
        }
    },
    {
        path: 'register',
        component: AviatorRegistrationPageComponent,
        canActivate: [AviatorRouteGuardService],
        //canActivate: [DwAuthGuardService],
        data: {
            routeId: 'register',
            display: 'Register',
            showInMenu: false,
            routeOrder: 16,
            referenceKey: 'register',
        }
    },
   
    {
        path: '**',
       // redirectTo: '',
        data: {
            showInMenu: false,
        },
        component: AviatorNotFoundComponent
    },
    // {
    //     path: '---missing-components---',
    //     children: [...DwComponentList, 
    //         { path: 't', component: ServiceDependenciesComponent},
    //         { path: 't1', component: DwGridColumnActionButtonsComponent}
    //        // { path: 't2', component: DwGridQuickSearchActionComponent},
            
    //     ], 
    // }, 

    // {
    //     path: "**",
    //     redirectTo: '',
    //     data: { 
    //         showInMenu: false
    //     }
    // },
    
];


//console.log("Quick Search Action Config", actionRegList);
//console.log("Quick Search Action Config", _dwActionGridQuickSearch);



// DwActionFunc<DwGridActionConfig>({
//     keyName: DwGridActionKeys.gridQuickSearch,
//     display: 'Quick Search',
//     actionType: DwActionType.gridAction,
//     decoratorType: DwDecoratorType.component,
//     configComponent: DwGridQuickSearchConfigComponent,
//     isGlobal: true,
//     allowOnce: true,
//   }, DwGridQuickSearchActionComponent);
  

// Add Dw Auth Guard to all routes (uses the requireAuthentication and CanAcessPermission data properties)
//DwRouteGuardUtil.secureRoutes(routes, DwAuthGuardService);
DwRouteGuardUtil.secureRoutes(routes, DwAuthGuardService, DwCanDeactivateGuard);

// @NgModule({
//     imports: [  RouterModule.forRoot(routes)],
//     exports: [RouterModule]
// })
// export class AppRoutingModule { }
@NgModule({
    imports: [
        RouterModule.forRoot(routes,
            {
                preloadingStrategy: PreloadAllModules,
                scrollPositionRestoration: 'enabled'
            }),
        DevwareAdminModule.forRoot()
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }